import { render } from "./UpdateSellerModal.vue?vue&type=template&id=29f3f821"
import script from "./UpdateSellerModal.vue?vue&type=script&lang=js"
export * from "./UpdateSellerModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__